const en_ja =
{
  "ALL": "全て",
  "About Clinic": "クリニックについて",
  "About Doctor": "医師について",
  "Actions": "操作",
  "Activate": "有効化",
  "Active": "有効",
  "Active Coupons": "有効クーポン",
  "Active Doctors": "稼働中の医師",
  "Active Pharmacies": "有効な薬局",
  "Active Status": "有効なステータス",
  "Add Coupon": "クーポンを追加",
  "Add Doctor": "医師を追加",
  "Add FAQ": "よくある質問を追加",
  "Add Image": "画像を追加",
  "Add Images": "画像を追加",
  "Add Manuals": "取扱説明書を追加",
  "Rows per page:": "1ページあたりの行数:",
  "Add Medicine": "薬を追加",
  "Add Pharmacy": "薬局を追加",
  "Add Product": "商品を追加",
  "Add Videos": "ビデオを追加",
  "Add medication": "薬を追加",
  "Add new Doctor": "新しい医師を追加",
  "Address": "住所",
  "Admin Portal": "管理ポータル",
  "Age": "年齢",
  "Amount": "金額",
  "Answer": "回答",
  "Auto Approve slot:": "自動承認スロット：",
  "Avg Revenue/Pharmacies": "平均収益/薬局",
  "Basic Details": "基本情報",
  "Cancel": "キャンセル",
  "Canceled Orders": "キャンセルされた注文",
  "Cannot create slots for past dates": "過去の日付にはスロットを作成できません",
  "Change Password": "パスワードの変更",
  "Choose Image": "画像の選択",
  "Choose a Image": "画像の選択",
  "City": "都市",
  "Clear All": "すべてクリア",
  "Click on the map or drag the marker to set the clinic location": "地図をクリックするか、マーカーをドラッグして診療所の場所を設定してください",
  "Clinic Address": "クリニックの住所",
  "Clinic Information": "クリニック情報",
  "Clinic Name": "クリニック名",
  "Completed Orders": "完了した注文",
  "Confirm Password": "パスワードを確認",
  "Confirm your new password": "新しいパスワードを確認",
  "Consultation Notes": "診察メモ",
  "Contact": "連絡先",
  "Contact Details": "連絡先詳細",
  "Coordinates:": "座標：",
  "Could not update Status": "ステータスを更新できませんでした",
  "Could not update coupon status": "クーポンステータスを更新できませんでした",
  "Coupon Code": "クーポンコード",
  "Coupon Name": "クーポン名",
  "Coupons": "クーポン",
  "Create Prescription": "処方箋を作成",
  "Creating Prescription...": "処方箋を作成中...",
  "Current Image": "現在の画像",
  "Current Password": "現在のパスワード",
  "Custom Package": "カスタムパッケージ",
  "Date": "日付",
  "Deactivate": "無効化",
  "Description": "説明",
  "Discard Changes": "変更を破棄",
  "Discount Value": "割引額",
  "Doctor": "医師",
  "Doctor Profile": "医師のプロフィール",
  "Doctor activated successfully": "医師を有効化しました",
  "Doctor added successfully!": "医師を追加しました！",
  "Doctor deactivated successfully": "医師を無効化しました",
  "Doctor updated successfully!": "医師を更新しました！",
  "Doctor with similar credentails already exists!": "同様の資格を持つ医師が既に存在します！",
  "Dose": "用量",
  "Drag and drop the image": "画像をドラッグ＆ドロップ",
  "Duration": "間隔",
  "Edit Doctor": "医師を編集",
  "Edit Profile": "プロフィールを編集",
  "Email Address": "メールアドレス",
  "End Date": "終了日",
  "Enter the code sent to your email and set your new password": "メールで送られてきたコードを入力し、新しいパスワードを設定してください",
  "Enter the doctor's information and assign them to a clinic.": "医師情報を入力し、クリニックに割り当ててください",
  "Enter your new password": "新しいパスワードを入力してください",
  "Error could not create slots!": "スロットの作成エラー！",
  "Error updating slot": "スロットの更新エラー",
  "Error while adding Doctor": "医師の追加エラー",
  "Error while updating Doctor": "医師の更新エラー",
  "Error while updating doctor status": "医師のステータス更新エラー",
  "Experience": "経験",
  "Experience (years)": "経験（年数）",
  "FAQs": "よくある質問",
  "Failed to fetch coupons": "クーポンの取得失敗",
  "Failed to load clinic data": "クリニックデータの読み込み失敗",
  "Failed to load pharmacies": "薬局データ読み込み失敗",
  "Failed to publish product": "商品の公開失敗",
  "Failed!": "失敗！",
  "First Name": "名",
  "First name is required": "名は必須です",
  "Last name is required": "姓は必須です",
  "Format: number + unit (e.g., 5mg, 2.5ml, 10units)": "形式：数値 + 単位（例：5mg、2.5ml、10ユニット）",
  "Frequency": "頻度",
  "From:": "開始時刻：",
  "Full Name": "フルネーム",
  "Gender": "性別",
  "Go to Today": "本日へ",
  "Height (cm)": "身長（cm）",
  "Here's Your Clinic Management Overview For Today": "本日のクリニック管理概要",
  "Highlight this product in a featured section.": "この商品を特集セクションでハイライト表示",
  "History": "履歴",
  "Images": "画像",
  "Inactive": "無効",
  "Inactive Pharmacies": "無効な薬局",
  "Join Date": "入職日",
  "Joining Date": "入職日",
  "Keep Editing": "編集を続ける",
  "Landline No.": "固定電話番号",
  "Landline Number": "固定電話番号",
  "Last Name": "姓",
  "Loading Google Maps...": "Google Mapsを読み込み中...",
  "Loading coupons...": "クーポンを読み込み中...",
  "Loading pharmacies...": "薬局を読み込み中...",
  "Loading prescription data...": "処方データを読み込み中...",
  "Loading prescription history...": "処方履歴を読み込み中...",
  "Loading profile...": "プロフィールを読み込み中...",
  "Logout": "ログアウト",
  "Manuals": "取扱説明書",
  "Medical ID": "医療ID",
  "Medications:": "薬:",
  "Medicine name": "薬名",
  "Method": "投与方法",
  "Minimum Order Value": "最低注文金額",
  "Name": "氏名",
  "New Onboardings": "新規入職",
  "New Orders": "新規注文",
  "New Password": "新しいパスワード",
  "New Prescription": "新規処方箋",
  "No Payment Data": "支払いデータはありません",
  "No coupons available": "利用可能なクーポンがありません",
  "No description available": "説明はありません",
  "No doctors have been added to the system yet.": "システムに医師が追加されていません",
  "No doctors match your search criteria.": "検索条件に一致する医師はいません",
  "No payment transactions found for this period.": "この期間の支払い取引は見つかりませんでした",
  "No payment transactions match your search criteria.": "検索条件に一致する支払い取引はありません",
  "No pharmacies available": "利用可能な薬局はありません",
  "No pharmacy data found": "薬局データが見つかりません",
  "No prescription history found": "処方履歴が見つかりません",
  "No recent activity": "最近の活動はありません",
  "No slots created for this date": "この日付に作成されたスロットはありません",
  "No slots found for this date": "この日付にスロットが見つかりません",
  "Not specified": "指定なし",
  "Notification": "通知",
  "OTP sent to your email successfully": "ワンタイムパスワードがメールに正常に送信されました",
  "Password Change": "パスワードの変更",
  "Password changed successfully!": "パスワードが正常に変更されました！",
  "Patient": "患者",
  "Patient Information": "患者情報",
  "Payment Methods": "支払い方法",
  "Pharmacies": "薬局",
  "Pharmacy Name": "薬局名",
  "Phone": "電話",
  "Phone No.": "電話番号",
  "Phone Number": "電話番号",
  "Please fix the errors before submitting": "送信前にエラーを修正してください",
  "Please review these interactions before submitting the prescription.": "処方箋を送信する前にこれらの相互作用を確認してください",
  "Please wait while we process your prescription": "処方箋の処理中ですので、しばらくお待ちください",
  "Postal Code": "郵便番号",
  "Potential Drug Interactions Detected": "潜在的な薬物相互作用が検出されました",
  "Prescription": "処方箋",
  "Prescription History": "処方履歴",
  "Price": "価格",
  "Primary Image": "メイン画像",
  "Product Code": "商品コード",
  "Product ID": "商品ID",
  "Product Name": "商品名",
  "Product published successfully!": "商品の公開に成功しました！",
  "Profile": "プロフィール",
  "Profile updated successfully!": "プロフィールの更新に成功しました！",
  "Publish Product": "商品の公開",
  "Q:": "Q:",
  "Question": "質問",
  "Recent Payment Activity": "最近の支払い状況",
  "Remove medication": "薬を削除",
  "Reported Symptoms": "申告された症状",
  "Reset Password": "パスワードをリセット",
  "Retry": "再試行",
  "Retry Loading": "再読み込み",
  "Search doctors...": "医師を検索...",
  "Select Package": "パッケージを選択",
  "Select Pharmacy*": "薬局を選択*",
  "Select Time (24-hour format):": "時間 (24時間形式)を選択：",
  "Select a past date to view history": "履歴を表示するために過去日付を選択",
  "Select duration": "期間を選択",
  "Select frequency": "頻度を選択",
  "Select or type medicine name": "薬剤名を選択または入力",
  "Settings": "設定",
  "Shop Japan Logo": "Shop Japanのロゴ",
  "Slot Duration (minutes):": "スロット時間（分）：",
  "Slot count:": "スロット数：",
  "Slot updated successfully": "スロットの更新成功",
  "Slots Booked": "予約済みスロット",
  "Specialty": "専門分野",
  "Start Date": "開始日",
  "Status": "ステータス",
  "Tell us about your clinic...": "クリニックについて教えてください...",
  "This patient has no previous prescriptions.": "この患者には過去の処方箋がありません",
  "To:": "終了時刻：",
  "Today": "本日",
  "Total Coupons": "合計クーポン",
  "Total Doctors": "合計の医師",
  "Total Orders": "合計注文",
  "Total Pharmacies": "合計薬局",
  "Total Usage": "合計使用量",
  "Transaction": "取引",
  "Try adjusting your search terms.": "検索条件を調整してみてください",
  "UNREAD": "未読",
  "Unsaved Changes": "保存されていない変更",
  "Update doctor information": "医師情報の更新",
  "Upload Image": "画像のアップロード",
  "Upload Image for the Clinic": "クリニックの画像をアップロード",
  "Verification Code": "確認コード",
  "Videos": "ビデオ",
  "View Profile": "プロフィールを見る",
  "We'll send you an OTP to verify your identity": "本人確認のため、ワンタイムパスワードをお送りします",
  "Website": "ウェブサイト",
  "Weight (kg)": "体重(kg)",
  "You have unsaved changes. Are you sure you want to cancel? All changes will be lost.": "保存されていない変更があります。キャンセルしてもよろしいですか？すべての変更が失われます",
  "images": "画像",
  "or": "または",
  "primary": "主要な",
  "Here you can manage all prescriptions": "ここで全ての処方箋を管理できます",
  "Manage and View all Patient information": "すべての患者情報を管理および表示する",
  "Manage and View all Appointments and Slots": "すべての予約とスロットを管理および表示する",
  "Manage and View all Doctors associated with your clinic": "クリニックに関連するすべての医師を管理および表示する",
  "Manage and View all Pharmacies associated with your clinic": "クリニックに関連するすべての薬局を管理および表示する",
  "Manage and View all Coupons associated with your clinic": "クリニックに関連するすべてのクーポンを管理および表示する",
  "Prescription API modified": "処方APIが変更されました",
  "Manage and update your account settings": "アカウント設定の管理と更新",
  "Doctors": "医師",
  "Appointments & Slots": "予約とスロット",
  "Billing & Payments": "請求と支払い",
  "Manage and View all Billing and Payments": "すべての請求と支払いを管理および表示する",
  "Bookings": "予約",
  "Manage and View all Bookings": "すべての予約を管理および表示する",
  "Manage and view your profile information": "プロフィール情報の管理と表示",
  "Welcome, {name}!": "{name}さん、ようこそ！",
  "Dashboard": "ダッシュボード",
  "Booking Management": "予約管理",
  "Patient Management": "患者管理",
  "Doctor Management": "医師管理",
  "Prescription Management": "処方管理",
  "Error loading dashboard data": "ダッシュボードデータの読み込みエラー",
  "Dashboard Overview": "ダッシュボード概要",
  "new": "新規",
  "Total Patients": "患者総数",
  "Registered patients": "登録済みの患者",
  "Total Appointments": "予約総数",
  "for today": "本日の件数",
  "Total Revenue": "総収益",
  "Total earnings": "総売上",
  "No Data Available": "データがありません",
  "Start adding patients and scheduling appointments to see your dashboard metrics.":
    "患者の追加と予約の登録を行うと、ダッシュボード指標が表示されます。",
  "For today's slots, minimum time must be": "本日のスロットは、最低時刻が必要です：",
  "From time is required": "開始時刻は必須です",
  "To time is required": "終了時刻は必須です",
  "Slot count must be greater than 0": "スロット数は0より大きい必要があります",
  "Slot duration must be greater than 0": "スロット時間は0より大きい必要があります",
  "To time must be after from time": "終了時刻は開始時刻より後でなければなりません",
  "Saving...": "保存中...",
  "Updating...": "更新中...",
  "Save Changes": "変更を保存",
  "Available Slots:": "利用可能なスロット：",
  "History": "履歴",
  "Date:": "日付：",
  "No date selected": "日付が選択されていません",
  "(Past)": "（過去）",
  "DONE": "完了",
  "OPEN": "営業中",            // ← たぶん既にあります（"OPEN"）
  "FULL": "満席",
  "Slots Booked": "予約済みスロット",
  "Select Time (24-hour format):": "時間 (24時間形式)を選択：",
  "Go to Today": "本日へ",
  "Unknown Patient": "不明な患者",
  "No email": "メールなし",
  "No contact": "連絡先なし",
  "Online": "オンライン",
  "online": "オンライン",
  "Offline": "オフライン",
  "Mins": "分",
  "Save": "保存",
  "Phone is required": "電話番号は必須です",
  "Specialty is required": "専門分野は必須です",
  "Gender is required": "性別は必須です",
  "Experience must be 0 or greater": "経験は0以上でなければなりません",
  "About section is required": "概要セクションは必須です",
  "About section must be 1000 characters or less": "概要セクションは1000文字以内でなければなりません",
  "Search patients...": "患者を検索...",
  "Name": "氏名",
  "Patient ID": "患者ID",
  "Contact": "連絡先",
  "Date of Birth": "生年月日",
  "Gender": "性別",
  "Last Visit": "最終受診",
  "Consult Type": "診療タイプ",
  "Male": "男性",
  "Female": "女性",
  "Week days": "平日",
  "Sun": "日",
  "Mon": "月",
  "Tue": "火",
  "Wed": "水",
  "Thu": "木",
  "Fri": "金",
  "Sat": "土",
  "Total package cost": "パッケージ総費用",
  "Error fetching patients": "患者データの取得エラー",

  "Showing": "表示中",
  "of": "件中",
  "Click Join to start video call": "参加をクリックしてビデオ通話を開始",
  "Waiting for patient to join...": "患者の参加をお待ちください...",
  "Connected": "接続済み",
  "Disconnected": "切断済み",
  "Join Call": "通話に参加",
  "Vital Signs": "バイタルサイン",
  "Health Records Not Available": "健康記録は利用できません",
  "Vital signs have not been collected or updated for this appointment": "この予約のバイタルサインは収集または更新されていません",
  "Session Notes": "セッションメモ",
  "Type your observations, diagnosis, treatment plan...": "観察、診断、治療計画を入力してください...",
  "When call ends notes will be saved automatically": "通話終了時にメモが自動保存されます",
  "You are in a call. End the call before leaving this page.": "通話中です。このページを離れる前に通話を終了してください。",
  "End Call": "通話終了",
  "Stay on Page": "ページにとどまる",
  "Complete appointment?": "予約を完了しますか？",
  "Leave consultation?": "診療を終了しますか？",
  "Was the appointment successfully completed?": "予約は正常に完了しましたか？",
  "Are you sure you want to go back to booking management?": "予約管理に戻ってもよろしいですか？",
  "Yes, Completed": "はい、完了",
  "Yes, Go Back": "はい、戻る",
  "Stay": "とどまる",
  "No": "いいえ",
  "Treatment Completed": "治療完了",
  "Appointment has been successfully completed": "予約が正常に完了しました",
  "Now you can go to Booking Management screen to create prescription": "これで、予約管理画面に移動して処方箋を作成できます",
  "Session notes have been saved": "セッションメモが保存されました",
  "Go to Booking Management": "予約管理へ移動",
  "No Patients Found": "患者が見つかりません",
  "No patients match your current filters. Try adjusting your search criteria.": "現在のフィルターに一致する患者はいません。検索条件を調整してください。",
  "No patients have been added to the system yet.": "システムに患者はまだ登録されていません。",
  "Clear All Filters": "すべてのフィルターをクリア",
  "Patient Details": "患者詳細",
  "Patient ID:": "患者ID：",
  "No prescription history found for this patient": "この患者の処方履歴が見つかりません",
  "Select Patient": "患者を選択",
  "User Name": "ユーザー名",
  "Transaction Date": "取引日",
  "Payment Method": "支払い方法",
  "Amount Paid": "支払金額",
  "Order ID": "注文ID",
  "Payment History": "支払い履歴",
  "Search by name, payment method...": "名前、支払い方法などで検索",
  "Total appointments": "合計予約数",
  "Total Appointments": "合計予約数",
  "Details": "詳細",
  "Health Assessment": "健康評価",
  "Notes": "メモ",
  "Other": "他の",
  "Prefer not to say": "回答しない",
  "Medical Information": "医療情報",
  "No medical information available.": "医療情報はありません。",
  "Height": "身長",
  "Weight": "体重",
  "BMI": "BMI",
  "Gender": "性別",
  "Symptoms": "症状",

  "Underweight": "低体重",
  "Normal": "標準",
  "Overweight": "過体重",
  "Obese": "肥満",

  "Initial Health Assessment": "初回健康評価",
  "Final Consultation Assessment": "最終診察評価",
  "No response provided": "回答はありません",
  "No health assessment data available.": "健康評価データはありません。",

  "Consultation Notes": "診察メモ",
  "Doctor's Notes": "医師のメモ",
  "Phone": "電話",
  "Call running in background": "通話がバックグラウンドで実行中",
  "Vital Signs": "バイタルサイン",
  "Blood Pressure": "血圧",

  "Target weight appears dangerously low. Medical review recommended.": "目標体重が危険なほど低い可能性があります。医師の確認を推奨します。",
  "High blood pressure reported in young patient.": "若年患者で高血圧が報告されています。",
  "Bookings for {date}": "【{date}】の予約一覧",
  "Patient Id:": "患者ID:",

  "Accept": "承認",
  "Decline": "却下",
  "Auto Approved": "自動承認",
  "Appointment Completed": "診療完了",
  "Create Prescription": "処方箋を作成",
  "Accepted": "承認済み",
  "Join Call": "通話に参加",
  "Cancelled": "キャンセル済み",
  "Rescheduled": "日程再調整",

  "Name": "氏名",
  "Email": "メール",
  "Contact": "連絡先",
  "Consult Type": "診療タイプ",
  "Actions": "操作",
  "Notifications": "通知",
  "Loading notifications...": "通知を読み込み中...",
  "No notifications yet": "まだ通知はありません",
  "We'll notify you when something important happens": "重要なお知らせがある場合に通知します",
  "Prescriptions": "処方箋一覧",
  "Here you can manage all prescriptions": "ここで全ての処方箋を管理できます",
  "Clinic Management": "クリニック管理",

  "Today": "今日",
  "No Bookings Found": "予約はありません",
  "No appointments were scheduled for {date}": "{date} の予約はありませんでした",
  "No appointments scheduled for {date}.": "{date} の予約はありません。",
  "Try selecting a different date or": "別の日付を選択するか、",
  "Go to Today": "今日へ移動",
  "Auto Approve slot": "自動承認スロット",
  "No Doctors Found": "該当する医師は見つかりません",
  "No doctors match your search criteria.": "検索条件に一致する医師はいません。",
  "No doctors have been added to the system yet.": "システムに医師はまだ追加されていません。",
  "Showing {{from}}-{{to}} of {{total}}": "表示：{{from}}~{{to}} / 全{{total}}件",
  "Total Processed": "処理済み合計",
  "Pending Payments": "保留中の支払い",
  "Failed Payments": "失敗した支払い",
  "Success Rate": "成功率",
  "Edit Slot": "スロットの編集",
  "Credit Card": "クレジットカード",
  "Primary payment method": "主要なお支払い方法",
  "Search transactions...": "取引を検索...",
  "Invoice": "請求書",
  "Download Receipt": "領収書をダウンロード",
  "View Details": "詳細を表示",
  "Package A": "パッケージ A",
  "Package B": "パッケージ B",
  "Package C": "パッケージ C",
  "Package D": "パッケージ D",
  "Package E": "パッケージ E",
  "Package F": "パッケージ F",
  "Package G": "パッケージ G",
  "Package": "パッケージ",
  "Custom": "カスタム",
  "Creating...": "作成中...",
  "Medications": "処方薬",
  "Change Patient": "患者を変更",
  "Search prescriptions...": "処方箋を検索...",
  "All Time": "全期間",
  "Last 7 days": "直近7日間",
  "Last 30 days": "直近30日間",
  "No Patients Available": "利用可能な患者がいません",
  "Select Patient to Continue": "続行するには患者を選択してください",
  "Please select a patient from your appointment list to view their prescription history or create new prescriptions.": "処方履歴を表示するか新しい処方箋を作成するには、予約一覧から患者を選択してください。",
  "Select Patient": "患者を選択",
  "Go Back": "戻る",
  "Need help? Try these options:": "お困りですか？次のオプションをお試しください：",
  "Refresh List": "一覧を更新",
  "View Appointments": "予約を表示",
  "Loading patients...": "患者を読み込み中...",
  "Patient ID not found": "患者IDが見つかりません",
  "Failed to load prescription history": "処方履歴の読み込みに失敗しました",
  "You do not have permission to view pharmacies": "薬局を表示する権限がありません",
  "Failed to load patient list": "患者リストの読み込みに失敗しました",
  "Please fix all validation errors before submitting": "送信前にすべての検証エラーを修正してください",
  "Please select a pharmacy": "薬局を選択してください",
  "Please select a package": "パッケージを選択してください",
  "Confirm Prescription": "処方箋の確認",
  "You are about to create a prescription with the following medications:": "次の薬剤で処方箋を作成しようとしています：",
  "This action cannot be undone. Continue?": "この操作は元に戻せません。続行しますか？",
  "Confirm": "確認",
  "Processing...": "処理中...",
  "Prescription created successfully!": "処方箋を作成しました！",
  "Invalid prescription data. Please check all fields.": "処方箋のデータが無効です。すべての項目を確認してください。",
  "You do not have permission to create prescriptions.": "処方箋を作成する権限がありません。",
  "Patient or pharmacy not found.": "患者または薬局が見つかりません。",
  "Action": "操作",
  "No patients match your search criteria": "検索条件に一致する患者はいません",
  "Select": "選択",
  "ID:": "ID：",
  "Once daily": "1日1回",
  "Twice daily": "1日2回",
  "Three times daily": "1日3回",
  "Four times daily": "1日4回",
  "Every 8 hours": "8時間ごと",
  "Every 12 hours": "12時間ごと",
  "As needed": "必要に応じて",
  "Weekly": "毎週",
  "3 days": "3日間",
  "5 days": "5日間",
  "7 days": "7日間",
  "10 days": "10日間",
  "14 days": "14日間",
  "21 days": "21日間",
  "30 days": "30日間",
  "3 months": "3か月",
  "1.7 mg ×3Month": "1.7 mg x3か月",
  "2.4 mg ×3Month": "2.4 mg ×3か月",
  "Remove Medication": "薬を削除",
  "Are you sure you want to remove this medication from the prescription?": "この薬を処方から削除してもよろしいですか？",
  "Dose is required": "用量は必須です",
  "Invalid dose format. Use format like \"5mg\", \"2.5ml\", \"10units\"": "用量の形式が無効です。「5mg」「2.5ml」「10units」のように入力してください",
  "Dose must be greater than 0": "用量は0より大きい必要があります",
  "Dose seems unusually high. Please verify": "用量が異常に多いようです。確認してください",
  "Medicine name is required": "薬剤名は必須です",
  "Medicine name too short": "薬剤名が短すぎます",
  "Medicine name too long": "薬剤名が長すぎます",
  "Medicine name cannot be only numbers": "薬剤名を数字だけにすることはできません",
  "Frequency is required": "頻度は必須です",
  "Duration is required": "期間は必須です",
  "Increased bleeding risk": "出血リスクの増加",
  "Risk of lactic acidosis": "乳酸アシドーシスのリスク",
  "Risk of hyperkalemia": "高カリウム血症のリスク",
  "Address not available": "住所は利用できません",
  "Failed to load patient address": "患者住所の読み込みに失敗しました",
  "Loading address...": "住所を読み込み中...",
  "No symptoms recorded": "症状の記録はありません",
  "Welcome Back": "お帰りなさい",
  "Enter your email and password to access your account": "メールアドレスとパスワードを入力してアカウントにアクセスしてください",
  "Username": "ユーザー名",
  "Enter your Login ID": "ログインIDを入力してください",
  "Password": "パスワード",
  "Enter your password": "パスワードを入力してください",
  "Remember me": "ログイン状態を保持する",
  "Forgot Password": "パスワードをお忘れですか？",
  "Signing In .....": "サインイン中 .....",
  "Sign In": "サインイン",
  "Verify Account": "アカウントを確認",
  "Reset Password": "パスワードをリセット",
  "Verify your account to complete the login process": "アカウントを確認してログインを完了してください",
  "Enter your email to receive a password reset code": "パスワードリセットコードを受け取るにはメールアドレスを入力してください",
  "Send OTP": "OTPを送信",
  "Send Reset Code": "リセットコードを送信",
  "Enter OTP": "OTPを入力",
  "Enter the OTP sent to your email for account verification": "アカウント確認のためメールに送信されたOTPを入力してください",
  "Verify Account": "アカウントを確認",
  "Verification Code": "確認コード",
  "New Password": "新しいパスワード",
  "Enter your new password": "新しいパスワードを入力してください",
  "Confirm Password": "パスワードを確認",
  "Confirm your new password": "新しいパスワードを再入力してください",
  "SJ Clinic Portal": "SJクリニックポータル",
  "Clinic name is required": "クリニック名は必須です",
  "Email is required": "メールアドレスは必須です",
  "Invalid email format": "無効なメールアドレス形式です",
  "Phone number is required": "電話番号は必須です",
  "Clinic address is required": "クリニック住所は必須です",
  "Failed to load Google Maps": "Google Mapsの読み込みに失敗しました",
  "Failed to initialize map": "マップの初期化に失敗しました",
  "Google Maps failed to initialize properly": "Google Mapsの初期化が正常に完了しませんでした",
  "Failed to load Google Maps script": "Google Mapsスクリプトの読み込みに失敗しました",
  "Failed to update profile. Please try again.": "プロフィールの更新に失敗しました。もう一度お試しください。",
  "Update profile": "プロフィールを更新",
  "Email is invalid": "無効なメールアドレスです",
  "Please enter all 6 digits": "6桁すべてを入力してください",
  "New password is required": "新しいパスワードは必須です",
  "Password must be at least 6 characters": "パスワードは6文字以上である必要があります",
  "Confirm password is required": "パスワード確認は必須です",
  "Passwords do not match": "パスワードが一致しません",
  "Failed to send OTP. Please try again.": "OTP送信に失敗しました。もう一度お試しください。",
  "Failed to change password. Please try again.": "パスワード変更に失敗しました。もう一度お試しください。",
  "Sending OTP...": "OTP送信中...",
  "Send OTP": "OTPを送信",
  "Enter your new password": "新しいパスワードを入力してください",
  "Confirm your new password": "新しいパスワードを再入力してください",
  "Changing Password...": "パスワード変更中...",
  "Error Updating Status": "ステータス更新エラー",
  "Try Again": "再試行",
  "Status Updated Successfully!": "ステータスの更新が成功しました！",
  "The prescription has been marked as dispatched.": "処方箋が発送済みとしてマークされました。",
  "Current Status: Dispatched": "現在のステータス：発送済み",
  "Order is on the way to destination": "注文は目的地に向かっています",
  "Prescription Order Ready": "処方箋注文準備完了",
  "Update the delivery status for this prescription": "この処方箋の配送ステータスを更新",
  "Ready for Dispatch": "発送準備完了",
  "A prescription order is ready to be dispatched.": "処方箋注文の発送準備が整いました。",
  "Click the button below to update the delivery status to \"Dispatched\"": "下のボタンをクリックして配送ステータスを「発送済み」に更新してください",
  "Update Status": "ステータス更新",
  "Updating Status...": "ステータス更新中...",
  "No response provided": "回答はありません",
  "No health assessment data available.": "健康評価データはありません。",
  "Target weight appears dangerously low. Medical review recommended.": "目標体重が危険なほど低い可能性があります。医師の確認を推奨します。",
  "High blood pressure reported in young patient.": "若年患者で高血圧が報告されています。",
  "Initial Health Assessment": "初回健康評価",
  "Final Consultation Assessment": "最終診察評価",
  "Doctor's Notes": "医師のメモ",
  "Test User": "テストユーザー",
  "Search transactions...": "取引を検索...",
  "No payment transactions match your search criteria.": "検索条件に一致する支払い取引はありません。",
  "No payment transactions found for this period.": "この期間の支払い取引は見つかりませんでした。",
  "Deleted": "削除済み",
  "Are you sure you want to delete this appointment? This action cannot be undone.": "この予約を削除してもよろしいですか？この操作は元に戻せません。",
  "Confirm Delete": "削除を確認",
  "Patient": "患者",
  "Time": "時間",
  "Appointment deleted successfully": "予約が正常に削除されました",
  "Download Prescriptions": "処方箋をダウンロードする",
  "No prescriptions to download": "ダウンロードする処方箋はありません",
  "Download": "ダウンロード",
  "Patient Name": "患者名",
  "Medication Count": "薬の数",
  "Prescription Number": "処方箋番号",
  "Pharmacy ID": "薬局ID",
  "User Address": "ユーザーアドレス",
  "Prescription_History": "処方箋履歴",
  "Total Price": "合計価格",
  "Shipping Fee": "送料",
  "Medication Fee": "薬代",
  "Consultation Fee": "相談料",
  "Delete Slot": "スロットの削除",
  "Disable Slot": "スロットを無効にする",
  "No results found": "結果が見つかりませんでした",
  "Try changing search or filter": "検索条件またはフィルターを変更してみてください",
  "Search": "検索",
  "Filter": "フィルター",
  "Last": "最後",
  "days": "日",
  "Clear Filters": "フィルターをクリアする",
  "Wegovy": "ウゴービ®",
  "Something went wrong": "何か問題が発生しました",
  "Success": "成功",
  "error": "エラー",
  "Delete Slot?": "スロットを削除しますか?",
  "Disable Slot?": "スロットを無効にしますか?",
  "Are you sure you want to": "本当にそうしたいですか？",
  "delete": "消去",
  "disable": "無効にする",
  "slot": "スロット",
  "on": "の上",
  "No, Keep Slot": "いいえ、スロットを維持します",
  "Yes": "はい",
  "Delete": "消去",
  "Disable": "無効にする",
  "Notes History": "メモ履歴",
  "No notes available": "利用可能なメモはありません",
  "No previous notes available": "利用可能な以前のメモはありません",
  "Unit is fixed for this package": "このパッケージではユニットが固定されています",
  "Units" : "単位",
  "months": "ヶ月",
  "for": "のために",
  "Quantity:": "量：",
  "Choose the treatment plan that best suits your needs": "ご自身のニーズに最適な治療プランをお選びください。",
  "e.g., 5mg": "例：5mg",
  "Age:": "年：",
  "Medical ID:": "医療ID:",
  "M.ID": "医師ID:"
};

export default en_ja;